import { defineStore } from 'pinia'

// This store manages the state of the mobile panel in the application.
export const useAppStates = defineStore('appStates', {
  state: () => ({
    mobilePanelOpen: false,
  }),
  actions: {
    openMobilePanel() {
      this.mobilePanelOpen = true
    },
    closeMobilePanel() {
      this.mobilePanelOpen = false
    },
    toggleMobilePanel() {
      this.mobilePanelOpen = !this.mobilePanelOpen
    },
  },
})
